
import { Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { VueConstructor } from 'vue';

const BreadCrumbs = (Vue as VueConstructor<Vue>).extend({
  data() {
    return {
      baseItem: {
        name: 'Support',
      },
      routeItem: {
        name: 'route',
      },
    };
  },
  computed: {
    ...mapState('userStore', {
      user: 'user',
    }),
  },
});
export default BreadCrumbs;
